(function createTitanScanRefs() {
  'use strict';

  function collect(root) {
    if (!root || typeof root.querySelector !== 'function') return null;
    const byId = (id) => root.querySelector(`#${id}`);
    const refs = Object.freeze({
      root,
      screens: [...root.querySelectorAll('.screen')],
      progress: root.querySelector('.tps-v2-progress'),
      stepText: byId('step-text'),
      progressBar: byId('progress-bar'),
      appMessage: byId('app-message'),
      soundToggle: byId('sound-toggle'),
      soundLabel: byId('sound-label'),
      resetButton: byId('reset-button'),
      heroVideo: byId('hero-video'),
      heroVideoToggle: byId('hero-video-toggle'),
      gameGrid: byId('game-grid'),
      gameNext: byId('game-next'),
      profileNext: byId('profile-next'),
      preferencesNext: byId('preferences-next'),
      monitorGrid: byId('monitor-grid'),
      budgetRange: byId('budget-range'),
      budgetOutput: byId('budget-output'),
      budgetUnlimited: byId('budget-unlimited'),
      inputModeBadge: byId('input-mode-badge'),
      inputKicker: byId('input-kicker'),
      inputIntroTitle: byId('input-intro-title'),
      inputDescription: byId('input-description'),
      inputRules: byId('input-rules'),
      startInput: byId('start-input-test'),
      inputViewportWarning: byId('input-viewport-warning'),
      inputModeOverride: byId('input-mode-override'),
      inputTime: byId('input-time'),
      inputHitLabel: byId('input-hit-label'),
      inputHits: byId('input-hits'),
      inputAccuracy: byId('input-accuracy'),
      inputExtraLabel: byId('input-extra-label'),
      inputExtra: byId('input-extra'),
      inputArena: byId('input-arena'),
      inputTarget: byId('input-target'),
      inputTest: byId('input-test'),
      inputTestCancel: byId('input-test-cancel'),
      inputCountdown: byId('input-countdown'),
      inputCountdownValue: byId('input-countdown-value'),
      inputCountdownLive: byId('input-countdown-live'),
      startReaction: byId('start-reaction-test'),
      reactionTest: byId('reaction-test'),
      reactionTestCancel: byId('reaction-test-cancel'),
      reactionArea: byId('reaction-area'),
      reactionMessage: byId('reaction-message'),
      reactionSubmessage: byId('reaction-submessage'),
      reactionRound: byId('reaction-round'),
      reactionLive: byId('reaction-live'),
      reactionCountdown: byId('reaction-countdown'),
      reactionCountdownValue: byId('reaction-countdown-value'),
      reactionCountdownLive: byId('reaction-countdown-live'),
      analysisStatus: byId('analysis-status'),
      playerClass: byId('player-class'),
      playerType: byId('player-type'),
      resultSummary: byId('result-summary'),
      inputScoreLabel: byId('input-score-label'),
      inputScore: byId('input-score'),
      reactionScore: byId('reaction-score'),
      accuracyScore: byId('accuracy-score'),
      resultDetails: byId('result-details'),
      analysisComments: byId('analysis-comments'),
      radarChart: byId('radar-chart'),
      radarSummary: byId('radar-summary'),
      recommendationReason: byId('recommendation-reason'),
      recommendedGpu: byId('recommended-gpu'),
      recommendedCpu: byId('recommended-cpu'),
      recommendedMemory: byId('recommended-memory'),
      recommendedMonitor: byId('recommended-monitor'),
      upgradeSummary: byId('upgrade-summary'),
      upgradeList: byId('upgrade-list'),
      recommendedPrice: byId('recommended-price'),
      budgetNote: byId('budget-note'),
      productImage: byId('product-image'),
      productStatus: byId('product-status'),
      productName: byId('product-name'),
      productDescription: byId('product-description'),
      productPrice: byId('product-price'),
      selectedProductName: byId('selected-product-name'),
      selectedProductStatus: byId('selected-product-status'),
      productCards: [...root.querySelectorAll('[data-product-card]')],
      productFallback: byId('product-fallback'),
      catalogDate: byId('catalog-date'),
      productLink: byId('product-link'),
      caseBox: byId('tps-case'),
      shareResult: byId('share-result'),
      shareX: byId('share-x'),
      shareLine: byId('share-line'),
      saveResultImage: byId('save-result-image'),
      copyResultUrl: byId('copy-result-url'),
      retryButton: byId('retry-button'),
      shareCanvas: byId('share-canvas'),
    });
    return refs.screens.length > 0 && Object.values(refs).every(Boolean) ? refs : null;
  }

  window.TitanScanRefs = Object.freeze({ collect });
})();
